export default build =>
    build.query({
        tagTypes: ['allExamSchools'],
        keepUnusedDataFor: 30,
        query() {
            //console.log("payload",payload)            
            return {
                url: '/exam/getallexamschools',
                method: 'GET',
               // body: payload,
            };
           
        },
       providesTags: ['allExamSchools']
    })
